export default __webpack_public_path__ + "static/bulletpoint-gh-integration-1744514318e8f65f45299755d37d3c1a.svg";